import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Fallback static data (used while loading or if API fails)
const FALLBACK = [
  {
    id: "tecnica",
    title: "Tecnica Heels",
    tagline: "Le fondamenta del movimento sui tacchi",
    image: "https://images.unsplash.com/photo-1525753609950-724d3715874d",
    description: "Caricamento…",
    bullets: [],
    sessions: [],
  },
  {
    id: "laboratorio",
    title: "Laboratorio Coreografico",
    tagline: "Dalla tecnica all'interpretazione",
    image: "https://images.unsplash.com/photo-1547153760-18fc86324498",
    description: "Caricamento…",
    bullets: [],
    sessions: [],
  },
  {
    id: "corso_completo",
    title: "Corso Completo",
    tagline: "Il percorso integrale dell'estate",
    image: "https://images.unsplash.com/photo-1760542941224-0287bfad7db7",
    description: "Caricamento…",
    bullets: [],
    sessions: [],
  },
];

export function useWorkshops() {
  const [workshops, setWorkshops] = useState(FALLBACK);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API}/workshops`)
      .then((res) => {
        if (mounted && Array.isArray(res.data) && res.data.length > 0) {
          setWorkshops(res.data);
        }
      })
      .catch(() => {})
      .finally(() => mounted && setLoading(false));
    return () => {
      mounted = false;
    };
  }, []);

  const byId = workshops.reduce((acc, w) => {
    acc[w.id] = w;
    return acc;
  }, {});

  return { workshops, byId, loading };
}

export const INSTAGRAM_URL = "https://www.instagram.com/mantelheelsexperience/";
